// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_mz-0";
export var animationContainer = "_mz-1";
export var itemPrice = "_mz-a";
export var itemizedContent = "_mz-9";
export var itemizedHeader = "_mz-7";
export var itemizedRow = "_mz-8";
export var itemizedSection = "_mz-6";
export var modalContent = "_mz-2";
export var orderName = "_mz-3";
export var refundOption = "_mz-4";
export var refundOptionsContainer = "_mz-5";
export var shippingLabel = "_mz-b";
export var totalRow = "_mz-c";